import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import Select from '@mui/material/Select';
import { FocusError } from 'focus-formik-error';
import { useFormik } from 'formik';
import { React, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { updateLoader } from '../../../_redux/LoaderSlice';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import RightSideBar from '../../../components/Rightsidebar/RightSideBar';
import { decrypt } from '../../../_utilities/_encryptDecryptHelper';
import { DashboardPlusicon } from '../../../Icons/DashboardPlusicon';
import {
  sessionExpired,
  getApi,
  postApi,
  putApi,
  deleteApi,
} from '../../../_redux/_apiHelpers/_apihelper';

import { GetUserInfo } from '../../../_utilities/getUserInfo';
const Segments = () => {
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [segments, setSegments] = useState([]);
  const [config, setConfig] = useState(configuration);
  const [filterValue, setFilterValue] = useState('');
  const [isLoadDoc, setIsLoadDoc] = useState(true);
  const [custPannelobj, setCustPannelobj] = useState(editPannelobj);
  const [isEditSegment, setIsEditSegment] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState('');
  const [noSegment, setNoSegments] = useState('');
  const segmentForm = JSON.parse(JSON.stringify(iniValues));
  const dispatch = useDispatch();
  const initialSnackbar = { type: '', message: '' };

  const [getUserId, setGetUserId] = useState(null);

  useEffect(() => {
    async function init() {
      const userIdData = await GetUserInfo();
      setGetUserId(userIdData);
    }
    init();
  }, []);

  useEffect(() => {
    if (isLoadDoc === true && getUserId && getUserId[0].id !== null) {
      let obj1 = {
        current: config.currentPage,
        offset:
          config.currentPage !== 1
            ? (config.currentPage - 1) * config.limitData + 1
            : 1,
      };
      fetchData(obj1);
      setIsLoadDoc(false);
    }
  }, [isLoadDoc, getUserId]);

  const fetchData = async (obj) => {
    try {
      setSegments([]);
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));

      const res = await getApi(
        `/mgmt/customers/segment?atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const jsonData = res.data;
      const myData = jsonData?.segments || [];

      if (jsonData.code === 200) {
        if (myData.length > 0) {
          const updatedData = myData.map((segment) => ({
            ...segment,
            segmentStatus_table:
              segment.segmentStatus === 0 ? 'Inactive' : 'Active',
          }));
          let configure = JSON.parse(JSON.stringify(config));
          configure.totalRecords = myData[0].totalCount;
          configure.currentPage = obj.current;
          setConfig(configure);
          setSegments(updatedData);
        } else if (jsonData.message === 'Segments are not defined') {
          setNoSegments(jsonData.message);
        }
      } else {
        dispatch(
          updateSnackbar({
            type: 'error',
            message: jsonData.message || 'Failed to fetch segments',
          })
        );
      }
    } catch (error) {
      console.error('Error fetching segments:', error);
      dispatch(
        updateSnackbar({
          type: 'error',
          message: error.message || 'Something went wrong',
        })
      );
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    } finally {
      dispatch(updateLoader(false));
    }
  };

  // for dynamic component received props
  const onReceiveActionHandler = async (type, object) => {
    //  if (type === "pagination") {
    //   if (filterValue !== '') {
    //     // getSearchResult(object, true);
    //   } else {
    //     fetchData(object);
    //   }
    // } else if (type === "searchResult") {
    //   // setFilterValue(object.keyword);
    //   getSearchResult(object, true);
    // } else if (type === "cancelSearchResult") {
    //   setFilterValue("");
    //   let obj1 = {
    //     current: 1,
    //     offset: 1
    //   };
    //   fetchData(obj1);
    // }
    // else
    if (type === 'detailspage') {
      if (getUserId !== null && getUserId[0].systemroles === 'Admin') {
        setIsRightSidePannel(true);
        setIsEditSegment(true);
        setCustPannelobj((prev) => ({
          ...prev,
          title: `${object.segmentName} (${object.segmentId})`,
        }));
        let segmentObj = {
          id: object.id,
          segmentId: object.segmentId,
          segmentName: object.segmentName,
          description: object.description,
          customerId: object.customerId,
          segmentStatus: object.segmentStatus,
        };
        setSelectedSegment(segmentObj);
      }
    } else if (type === 'pageRange') {
      setConfig({
        ...config,
        limitData: (config.limitData = object),
        recordperPage: (config.limitData = object),
        currentPage: 1,
      });
      // let obj1 = { current: 1, offset: object, limit: object };
      // fetchData(obj1);
    } else if (type === 'scroll') {
      const element = document.getElementById('segmentsTableContainer');
      element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  };

  const onReceivePropsHandler = (pannel, load) => {
    setIsRightSidePannel(pannel);
    setIsLoadDoc(load);
  };

  const userHandler = (type, data) => {
    setIsRightSidePannel(true);
    setSelectedSegment('');
    setIsEditSegment(false);
  };
  const storedTheme = JSON.parse(localStorage.getItem('themeSettings')) || '';

  return (
    <>
      {noSegment === '' ? (
        <div id="segmentsTableContainer">
          <div
            className="addusersection"
            style={{ display: 'flex', height: '34px', gap: '10px', alignItems: 'center' }}
            onClick={() => userHandler('Create', ' ')}
          >
            <DashboardPlusicon width={35} height={36} />
            <h4 className="addnewusertext">Create Segment</h4>
          </div>

          <div
            id="customerUser"
            style={{ background: '#fff', padding: '0px 30px 47px' }}
          >
            {/* for dynamic Table */}
            {segments.length > 0 && (
              <DynamicTable
                config={config}
                data={segments}
                colmns={columnsData}
                actionDropdown={actionsDropdownData}
                actions={actionsList}
                filterValue={filterValue}
                noDataText={'No Data'}
                addModel={addNewModel}
                searchKeyWord=""
                onReceiveActionProps={(type, obj) =>
                  onReceiveActionHandler(type, obj)
                }
              />
            )}
            {segments.length === 0 && (
              <DynamicTable
                config={config}
                data={segments}
                colmns={columnsData}
                actionDropdown={actionsDropdownData}
                actions={actionsList}
                filterValue={filterValue}
                noDataText={'No Data'}
                addModel={addNewModel}
                searchKeyWord=""
                onReceiveActionProps={(type, obj) =>
                  onReceiveActionHandler(type, obj)
                }
              />
            )}
          </div>
        </div>
      ) : (
        <Box
          sx={{
            border: '1px dashed #e5e5e5',
            padding: 3,
            marginTop: 2,
            textAlign: 'center',
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
              src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
              alt="No data"
            />
          <Typography variant="h6" color="textSecondary">
            {noSegment}
          </Typography>
        </Box>
      )}

      <div className="rightsidebarbtn" id="customerUser">
        {isRightSidePannel ? (
          <RightSideBar
            componentData={
              <ComponentRenderData
                componentType={isEditSegment ? 'EditSegment' : 'AddSegment'}
                onReceivechildProps={onReceivePropsHandler}
                getJobCode={getUserId[0].customerId}
                input={isEditSegment ? selectedSegment : segmentForm}
              />
            }
            componentLayout={isEditSegment ? custPannelobj : pannelobj}
            onReceiveProps={onReceivePropsHandler}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

const ComponentRenderData = ({
  onReceivechildProps,
  componentType,
  getJobCode,
  input,
}) => {
  const [segmentDetails, setSegmentDetails] = useState(input);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

  const initialSnackbar = { type: '', message: '' };
  const dispatch = useDispatch();

  const handleChange = (event) => {
    let { name, value } = event.target;

    formik.values[name] = value;
    setSegmentDetails((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const validationSchema = Yup.object({
    segmentName: Yup.string()
      .min(3, 'Must be min 3 characters')
      .max(20, 'Must be less than 20 ')
      .required('Please enter segment name'),
    description: Yup.string().required('Please enter segment description'),
  });

  const formik = useFormik({
    initialValues: input,
    validationSchema,
    onSubmit: async (value) => {
      const isEditMode = componentType === 'EditSegment';
      try {
        setDisableSubmitBtn(true);
        dispatch(updateLoader(true));
        dispatch(updateSnackbar(initialSnackbar));

        let response;
        if (isEditMode) {
          value.customerId = getJobCode;
          response = await putApi(
            `/mgmt/customers/segment?atsAdmin=true`,
            value,
            process.env.REACT_APP_USE_MANAGEMENT
          );
        } else {
          response = await postApi(
            `/mgmt/customers/${getJobCode}/segment?atsAdmin=true`,
            value,
            process.env.REACT_APP_USE_MANAGEMENT
          );
        }

        const res = response.data;

        if (res.code === 200) {
          setSegmentDetails([]);
          setTimeout(() => {
            dispatch(
              updateSnackbar({
                type: 'success',
                message: res.message || 'Success',
              })
            );
          }, 1200);
          onReceivechildProps(false, true);
        } else {
          dispatch(
            updateSnackbar({
              type: 'error',
              message: res.message || 'Something went wrong',
            })
          );
        }
      } catch (error) {
        console.error('Segment Submit Error:', error);
        if (
          error?.response?.status === 405 ||
          error?.response?.status === 406
        ) {
          return sessionExpired(error?.response?.data?.message);
        }
        dispatch(
          updateSnackbar({
            type: 'error',
            message: error.message || 'An unexpected error occurred',
          })
        );
      } finally {
        setDisableSubmitBtn(false);
        dispatch(updateLoader(false));
      }
    },
  });

  return (
    <>
      {segmentDetails.segmentName !== undefined ? (
        <div className="groupfields">
          <FocusError formik={formik} />
          <div
            style={{
              display: 'flex',
              flexFlow: 'wrap',
              marginTop: '40px',
              gap: '25px',
            }}
          >
            <div style={{ width: '100%' }}>
              <TextField
                className="boldlabeluser"
                id=""
                label="Segment Name* &nbsp;"
                variant="outlined"
                style={{ width: '100%' }}
                name="segmentName"
                value={segmentDetails.segmentName}
                onChange={handleChange}
                onKeyUp={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.segmentName && formik.touched.segmentName
                    ? true
                    : false
                }
                helperText={
                  formik.errors.segmentName && formik.touched.segmentName
                    ? formik.errors.segmentName
                    : ''
                }
              />
            </div>

            <div style={{ width: '100%' }}>
              <TextField
                className="boldlabeluser"
                id=""
                label="Segment Description* &nbsp;"
                variant="outlined"
                style={{ width: '100%' }}
                name="description"
                value={segmentDetails.description}
                onChange={handleChange}
                onKeyUp={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.description && formik.touched.description
                    ? true
                    : false
                }
                helperText={
                  formik.errors.description && formik.touched.description
                    ? formik.errors.description
                    : ''
                }
              />
            </div>

            <div style={{ width: '100%' }}>
              <FormControl
                fullWidth
                error={
                  formik.errors.segmentStatus && formik.touched.segmentStatus
                    ? true
                    : false
                }
              >
                <InputLabel className="boldSelectlabel" shrink={true}>
                  Segment Status*
                </InputLabel>
                <Select
                  style={{ width: '100%', height: '53px' }}
                  id="adduserfield"
                  value={segmentDetails.segmentStatus}
                  label="Segment Status* "
                  name="segmentStatus"
                  onFocus={formik.handleBlur}
                  onChange={handleChange}
                >
                  <MenuItem className="selectOptions" value={1}>
                    Active
                  </MenuItem>
                  <MenuItem className="selectOptions" value={0}>
                    Inactive
                  </MenuItem>
                </Select>
                <FormHelperText>
                  {formik.errors.segmentStatus && formik.touched.segmentStatus
                    ? formik.errors.segmentStatus
                    : ''}
                </FormHelperText>
              </FormControl>
            </div>
          </div>

          <div
            style={{ marginLeft: '728px', position: 'absolute', bottom: '15%' }}
          >
            <Button
              className="usersavebtn"
              variant="contained"
              type="submit"
              size="small"
              disableSubmitBtn={disableSubmitBtn}
              onClick={formik.handleSubmit}
            >
              {componentType === 'EditSegment' ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default Segments;

const pannelobj = {
  title: 'Create Segment',
  description: '',
  bgImage: '',
};

const editPannelobj = {
  title: '',
  description: '',
  bgImage: '',
};

// for dynamic Table config Object
const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: '',
  limitData: 10,
  isCheckAlignRight: false,
  isPaginationTop: false,
  isSearchServer: true,
  isPagingServer: false,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = [];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: false,
};

const iniValues = {
  segmentName: '',
  description: '',
  segmentStatus: 1,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: 'Segment ID',
    mappingName: 'segmentId',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: ' dynatablebodytext text-center ',
    type: 'segments',
    width: '',
    isEdit: true,
    nagigate: 'detailspage',
  },
  {
    id: 2,
    displayName: 'Segment Name',
    mappingName: 'segmentName',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: ' dynatablebodytext text-center ',
    type: 'segments',
    width: '',
    isEdit: true,
    nagigate: 'detailspage',
  },
  {
    id: 3,
    displayName: 'Segment Description',
    mappingName: 'description',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: ' dynatablebodytext text-center ',
    type: 'segments',
    width: '',
    isEdit: true,
    nagigate: 'detailspage',
  },
  {
    id: 4,
    displayName: 'Segment Status',
    mappingName: 'segmentStatus_table',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: ' dynatablebodytext text-center ',
    type: 'segments',
    width: '',
    isEdit: true,
    nagigate: 'detailspage',
  },
];

const addNewModel = {
  url: '',
  displayName: '',
};
